module.exports = __webpack_public_path__ + "img/skillsD-5.48aff83f.png";